
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/snorapport",
      function () {
        return require("private-next-pages/[region]/snorapport.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/snorapport"])
      });
    }
  